import React, { FC } from "react";
import { getAvailability, withAuthorization, Analytics } from "../../../utilities";
import MultiLineDiv from "../../MultiLineDiv/MultiLineDiv";
import { PlayButton } from "../../Buttons";
import { PlayImage } from "../../ReactImage";
import ProgressBar from "../../ProgressBar/ProgressBar";
import { StoreProps, withStore } from "../../../store";
import classnames from "classnames";
import { Image } from "../../../assets/images";
import { EpisodeItem } from "../../../types";
import "./ListItem.scss";

const AuthorizedMultiLineDiv = withAuthorization(MultiLineDiv);

interface ListItemProps {
  contentItem: EpisodeItem;
  enableAbroadBanner: () => void;
}

const ListItem: FC<ListItemProps & StoreProps> = ({ contentItem, store, enableAbroadBanner }) => {
  const { settings: { quality }, country, isAbroad } = store;
  let progress;
  const {
    tile,
    name,
    duration,
    description,
    certifications
  } = contentItem;
  const { image, subHeader } = tile;
  const meta = getAvailability(contentItem);

  //  useEffect(() => {
  //   console.log('**************** INSIDE USEEFFECT OF LISTITEM ****************');
  //   const isBannerElement = document.querySelector<HTMLElement>(".app-body .abroad-alert");
  //   if(isBannerElement){
  //     console.log("FOUND BANNER COMPONENT");
  //     //isBannerElement.remove();
  //     isBannerElement.style.display = "none";
  //     console.log('DELETED BANNER COMPONENT!!!');
  //   }
  // }, []);



  // const onclickHandler = async () => {
  //   // if(!["MY", "SG"].includes(country)? true : false){
  //   //   await setIsAbroadFlag(true);
  //   //   console.log("Abroad check passed");
  //   // }else{
  //   //   console.log("Abroad check failed");
  //   //   await setIsAbroadFlag(false);
  //   // }
  //   if(isAbroad){
  //     enableAbroadBanner();
  //   }
  //   // console.log("GETTING STORE VALUE FROM LISTITEM COMPONENT => ", store);
  // }

  // const countryCheck = !["MY", "SG"].includes(country)? true : false;
  if (contentItem.video_id) {
    progress = ((window.positionData?.[contentItem.video_id] || 0) / contentItem.duration);
  }
  // console.log("progress: ", progress)
  const inProgress = progress !== null && progress > 0;
  return (
    <div className={classnames("ListItem", { "in-progress": inProgress })}>
      <div className="ListItem__image">
        <PlayButton small className="ListItem__play-button" contentItem={contentItem} enableAbroadBanner={enableAbroadBanner} />
        {image && image !== undefined && image.url !== null && (
          <PlayImage alt="list"
            contentItem={contentItem}
            src={ image.url }
            // src={ countryCheck ? Image.SmallFallback : image.url}
            onClick={() => {
              Analytics.userActionSelectPlayableContent(contentItem);
              enableAbroadBanner
            }}
          />
        )}
         {/* <PlayImage alt="list" src={image && image.url} contentItem={contentItem} onClick={onclickHandler}/> */}
        { inProgress && <ProgressBar progress={progress} /> }
      </div>
      <AuthorizedMultiLineDiv className="ListItem__header" maxLines="3" contentItem={contentItem} onClick={() => Analytics.userActionSelectPlayableContent(contentItem)}>
        {name}
      </AuthorizedMultiLineDiv>
      <div className="ListItem__subheader">
        <div className="ListItem__duration">{Math.floor(duration / 60) + " min"}</div>
        {(certifications?.length) && <div className="ListItem__rating">{certifications[0].name}</div>}
        <div className="ListItem__hd">{quality}</div>
      </div>
      <MultiLineDiv className="ListItem__description" maxLines="3">{description ?? subHeader}</MultiLineDiv>
      <div className="ListItem__meta">{meta}</div>
    </div>
  )
}

export default withStore(ListItem as FC<ListItemProps>);
